"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTCheckBox = void 0;
var React = require("react");
require("./SPOTCheckBox.scss");
var classnames_1 = require("classnames");
var SPOTCheckBox = function (props) {
    var register = props.register, name = props.name;
    var error = props.errors && props.errors[props.name];
    return (React.createElement("div", { id: props.id, "data-test": props.testId, className: (0, classnames_1.default)({
            "checkbox-field": true,
            "checkbox-error": error
        }) },
        React.createElement("label", { htmlFor: props.name, className: props.disabled ? "disabled" : "" },
            React.createElement("input", __assign({ id: props.name, value: props.name, checked: props.checked, type: "checkbox", disabled: props.disabled }, register(name, {
                required: props.required,
                onChange: function (e) {
                    if (props.onChange) {
                        props.onChange(e);
                    }
                }
            }))),
            props.checked && React.createElement("div", { className: "box icon-checkmark" }),
            !props.checked && React.createElement("div", { className: "box" }),
            React.createElement("span", { className: "text" }, props.label)),
        error && React.createElement("span", { className: "checkboxErrorMessage" }, error.message)));
};
exports.SPOTCheckBox = SPOTCheckBox;
//# sourceMappingURL=SPOTCheckBox.js.map